export var CONVERSATION_FIELD_MAP;
(function (CONVERSATION_FIELD_MAP) {
    CONVERSATION_FIELD_MAP["USER_NAME"] = "27533087649044";
    CONVERSATION_FIELD_MAP["USER_EMAIL"] = "27533142242580";
    CONVERSATION_FIELD_MAP["ERROR_CODE"] = "27533154029716";
    CONVERSATION_FIELD_MAP["PROPERTY_ADDRESS"] = "27687055266836";
    CONVERSATION_FIELD_MAP["INTERACTION_ID"] = "27687083995540";
    CONVERSATION_FIELD_MAP["PAGE_URL"] = "27687140403732";
    CONVERSATION_FIELD_MAP["TRANSACTION_ID"] = "27687082119060";
})(CONVERSATION_FIELD_MAP || (CONVERSATION_FIELD_MAP = {}));
